import { useEffect, useRef } from "react";
import { Toast } from "bootstrap";
import { ValidateInfoSVG } from "../../../assets/imageImport";

export const ValidationInfoMessage = ({
  show = false,
  handleHidden,
  message = "",
  title = "Please Note.",
  className = "",
}) => {
  const toastRef = useRef(null);

  useEffect(() => {
    if (toastRef) {
      const toast = new Toast(toastRef.current, { delay: 10000 });
      if (toastRef.current) {
        if (show == true || message != "") {
          toast.show();
        } else if (show == false || message == "") {
          toast.hide();
        }
        toastRef.current.addEventListener("hidden.bs.toast", () => {
          if (handleHidden) handleHidden();
        });
      }
      return () => {
        if (toastRef.current) {
          toastRef.current.removeEventListener("hidden.bs.toast", () => {
            if (handleHidden) handleHidden();
          });
        }
      };
    }
  }, [show, message]);

  return (
    <div
      ref={toastRef}
      className="toast fav-error-toast w-100 mt-3 mb-3"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div className="toast-body fav-orderno-not d-flex align-content-center justify-content-between">
        <div className="fav-ordernoNot-lft d-flex align-items-start justify-content-between">
          <div>
            <ValidateInfoSVG />
          </div>
          <div className="fav-ordernoNot-info">
            <h5 className="fw-semibold">{title}</h5>
            <p className="fw-normal col-fs-13 fs-14 w-100 m-0">{message}</p>
          </div>
        </div>
        <div className="ct-close">
          <button type="button" className="btn-close" data-bs-dismiss="toast" aria-label="Close" />
        </div>
      </div>
    </div>
  );
};
